<script setup lang="ts">
import type { VBtn } from 'vuetify/components';

type PropsType = {
    size?: VBtn['$props']['size'];
    variant?: VBtn['$props']['variant'];
    density?: VBtn['$props']['density'];
    prependIcon?: string;
    appendIcon?: string;
    elevation?: number;
    flat?: boolean;
    color?: string;
};

withDefaults(defineProps<PropsType>(), {
    size: 'default',
    elevation: 0,
    color: 'primary',
    variant: 'elevated',
    density: 'default',
});

defineEmits<{
    click: [event: MouseEvent];
}>();

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VBtn
        :color="color"
        :variant="variant"
        :size="size"
        :prepend-icon="prependIcon"
        :append-icon="appendIcon"
        :elevation="elevation"
        :density="density"
        :flat="flat"
        v-bind="$attrs"
        @click="$emit('click', $event)"
    >
        <slot />
    </VBtn>
</template>

<style scoped lang="scss">
.v-btn {
    letter-spacing: normal;
}
.v-btn.btn-dialog-cta-action {
    --v-btn-height: 34px;
    padding-inline: 16px;
    text-transform: none;
}
</style>
